class LazyImages {
  constructor() {
    this.initialize();
  }

  initialize() {
    this.lazyImages = document.querySelectorAll('img[loading=lazy]');
    this.lazyImages.forEach(image => {
      if(image.complete) {
        image.classList.add('loaded');
      } else {
        image.classList.add('lazy');
        image.onload = () => {
          image.classList.add('loaded')
        }
      }
    })
  }
}

const lazyImages = new LazyImages();